import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-welcome" }

import PasswordInput from "@/account/components/inputs/password-input.vue";
import PhoneInput from "@/account/components/inputs/phone-input.vue";
import { authenticationErrors, authenticationData } from "@/account/composables/use-authentication-data";

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'login-welcome',
  setup(__props, { expose: __expose }) {

const phoneInput = ref(null);
const passwordInput = ref(null);

const checkIfIsValid = async () => {
    return phoneInput.value.checkIfIsValid() && passwordInput.value.checkIfIsValid();
};

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PhoneInput, {
      ref_key: "phoneInput",
      ref: phoneInput,
      class: "login-welcome__phone",
      modelValue: _unref(authenticationData).userName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authenticationData).userName) = $event)),
      name: "phone",
      disabled: true,
      "error-message": _unref(authenticationErrors).phoneErrorMessage,
      "onUpdate:errorMessage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authenticationErrors).phoneErrorMessage) = $event))
    }, null, 8, ["modelValue", "error-message"]),
    _createVNode(PasswordInput, {
      ref_key: "passwordInput",
      ref: passwordInput,
      class: "login-welcome__password",
      modelValue: _unref(authenticationData).password,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authenticationData).password) = $event)),
      name: "password",
      "error-message": _unref(authenticationErrors).passwordErrorMessage,
      "onUpdate:errorMessage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authenticationErrors).passwordErrorMessage) = $event)),
      focus: true
    }, null, 8, ["modelValue", "error-message"])
  ]))
}
}

})